module.exports = __webpack_public_path__ + "media/img/bg-contact-48baa0a2611d58b20b4110b2a01f300f.png";